// ======================================================================
// FILE:
// src/modules/service_crm/satisfaction/pages/SatisfactionListPage.js
//
// MODULE: Service CRM
// FEATURE: Customer Satisfaction Queue
// ======================================================================

import React, {
  useState,
  useEffect,
  useCallback,
} from "react";

import satisfactionService
  from "../../services/serviceSatisfactionService";

import SatisfactionKpiBar
  from "../components/SatisfactionKpiBar";

import SatisfactionFilterBar
  from "../components/SatisfactionFilterBar";

import SatisfactionTable
  from "../components/SatisfactionTable";

import SatisfactionPagination
  from "../components/SatisfactionPagination";

import SatisfactionFormDrawer
  from "../components/SatisfactionFormDrawer";

import ServiceTicketViewDrawer
from "../../tickets/components/ServiceTicketViewDrawer";


export default function SatisfactionListPage() {

  const [rows, setRows] =
    useState([]);

  const [pagination, setPagination] =
    useState({});

  const [page, setPage] =
    useState(1);

  const [pageSize, setPageSize] =
    useState(10);

  const [filters, setFilters] =
    useState({});

  const [loading, setLoading] =
    useState(false);

  const [
  ticketDrawerOpen,
  setTicketDrawerOpen
] = useState(false);

const [
  selectedTicketId,
  setSelectedTicketId
] = useState(null);


    // ============================================================
  // DRAWER STATE
  // ============================================================

  const [drawerOpen, setDrawerOpen] =
    useState(false);

  const [selectedTicket, setSelectedTicket] =
    useState(null);

  const [drawerMode, setDrawerMode] =
    useState("create");

  const [
    selectedSatisfactionId,
    setSelectedSatisfactionId
  ] = useState(null);

  const hasFilters =
    Object.keys(filters || {}).length > 0;

  // ============================================================
  // LOAD
  // ============================================================

  const load = useCallback(
    async () => {

      setLoading(true);

      try {

        const res =
          await satisfactionService
            .listSatisfaction({

              page,

              per_page: pageSize,

              ...filters,
            });

        setRows(
          res.data || []
        );

        setPagination(
          res.pagination || {}
        );

      } catch (err) {

        console.error(
          "Failed to load satisfaction queue",
          err
        );

      } finally {

        setLoading(false);
      }

    },
    [
      page,
      pageSize,
      filters,
    ]
  );

  useEffect(() => {

    load();

  }, [load]);

  // ============================================================
  // ACTIONS
  // ============================================================

  
  
  
  const handleAdd = (row) => {

    setSelectedTicket(row);

    setSelectedSatisfactionId(null);

    setDrawerMode("create");

    setDrawerOpen(true);
  };

  const handleView = (row) => {

    setSelectedTicket(row);

    setSelectedSatisfactionId(
      row.satisfaction_id
    );

    setDrawerMode("view");

    setDrawerOpen(true);
  };

  const handleEdit = (row) => {

    setSelectedTicket(row);

    setSelectedSatisfactionId(
      row.satisfaction_id
    );

    setDrawerMode("edit");

    setDrawerOpen(true);
  };

  const handleTicket = (row) => {

  setSelectedTicketId(
    row.ticket_id
  );

  setTicketDrawerOpen(true);
};


  // ============================================================
  // DRAWER CLOSE
  // ============================================================

  const handleCloseDrawer = () => {

    setDrawerOpen(false);

    setSelectedTicket(null);

    setSelectedSatisfactionId(null);
  };

  // ============================================================
  // DRAWER SUCCESS
  // ============================================================

  const handleDrawerSuccess = () => {

    handleCloseDrawer();

    load();
  };

  return (

    <div>

      {/* ====================================================== */}
      {/* HEADER */}
      {/* ====================================================== */}

      <div
        style={{
          background:
            "linear-gradient(90deg, #0d6efd, #3d8bfd)",

          borderRadius: 14,

          padding: "16px 22px",

          color: "#fff",

          display: "flex",

          justifyContent:
            "space-between",

          alignItems: "center",

          marginBottom: 20,
        }}
      >

        <div>

          <div
            style={{
              fontSize: 20,
              fontWeight: 700,
            }}
          >
            Customer Satisfaction
          </div>

          <div
            style={{
              fontSize: 13,
              opacity: 0.9,
            }}
          >
            Manage customer follow-up
            and satisfaction surveys
          </div>

        </div>

      </div>

      {/* ====================================================== */}
      {/* KPI */}
      {/* ====================================================== */}

      <SatisfactionKpiBar
        rows={rows}
      />

      {/* ====================================================== */}
      {/* FILTERS */}
      {/* ====================================================== */}

      <SatisfactionFilterBar

        filters={filters}

        onApply={(f) => {

          setPage(1);

          setFilters(f);
        }}
      />

      {/* ====================================================== */}
      {/* TABLE */}
      {/* ====================================================== */}

      <SatisfactionTable

        rows={rows}

        loading={loading}

        hasFilters={hasFilters}

        onAdd={handleAdd}

        onView={handleView}

        onEdit={handleEdit}

        onTicket={handleTicket}
      />

      {/* ====================================================== */}
      {/* PAGINATION */}
      {/* ====================================================== */}

      <SatisfactionPagination

        page={page}

        pageSize={pageSize}

        total={
          pagination.total || 0
        }

        onPageChange={
          setPage
        }

        onPageSizeChange={(size) => {

          setPage(1);

          setPageSize(size);
        }}
      />

      {/* ====================================================== */}
      {/* DRAWER */}
      {/* ====================================================== */}

      <SatisfactionFormDrawer

        open={drawerOpen}

        ticket={selectedTicket}

        mode={drawerMode}

        satisfactionId={
          selectedSatisfactionId
        }

        onClose={
          handleCloseDrawer
        }

        onSuccess={
          handleDrawerSuccess
        }
      />

      <ServiceTicketViewDrawer

        open={ticketDrawerOpen}

        ticketId={selectedTicketId}

        onClose={() =>
          setTicketDrawerOpen(false)
        }
      />

    </div>
  );
}